"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalForm = require("react-final-form");
var _ui = require("@unite-us/ui");
var _lodash = require("lodash");
var _utils = require("./utils/utils");
var _getFormProps2 = require("./utils/getFormProps");
var NotificationSettings = function NotificationSettings(_ref) {
  var submitForm = _ref.submitForm,
    submitting = _ref.submitting,
    currentEmployee = _ref.currentEmployee,
    enums = _ref.enums,
    flags = (0, _flags.default)(_ref);
  var notificationPreferences = currentEmployee.notification_preferences;
  var showMessaging = flags.showMessaging,
    showTasks = flags.showTasks;
  var reminderOptions = (0, _utils.formatOptions)((0, _lodash.get)(enums, 'preferences.trinary', {}));
  var _getFormProps = (0, _getFormProps2.getFormProps)({
      notificationPreferences: notificationPreferences,
      flags: flags,
      enums: enums
    }),
    overallProps = _getFormProps.overallProps,
    clientProps = _getFormProps.clientProps,
    referralProps = _getFormProps.referralProps,
    messageProps = _getFormProps.messageProps,
    paymentProps = _getFormProps.paymentProps,
    reminderProps = _getFormProps.reminderProps,
    programProps = _getFormProps.programProps,
    taskProps = _getFormProps.taskProps;
  var overallAll = !(0, _lodash.find)(overallProps, ['value', false]);
  var clientAll = !(0, _lodash.find)(clientProps, ['value', false]);
  var referralAll = !(0, _lodash.find)(referralProps, ['value', false]);
  var messageAll = !(0, _lodash.find)(messageProps, ['value', false]);
  var paymentAll = !(0, _lodash.find)(paymentProps, ['value', false]);
  var reminderAll = !(0, _lodash.find)(reminderProps, ['value', 'off']);
  var programAll = !(0, _lodash.find)(programProps, ['value', false]);
  var taskAll = !(0, _lodash.find)(taskProps, ['value', false]);
  var notificationAll = overallAll && clientAll && referralAll && messageAll && paymentAll && reminderAll && programAll;
  var allProps = [].concat((0, _toConsumableArray2.default)(overallProps), (0, _toConsumableArray2.default)(clientProps), (0, _toConsumableArray2.default)(referralProps), (0, _toConsumableArray2.default)(messageProps), (0, _toConsumableArray2.default)(paymentProps), (0, _toConsumableArray2.default)(reminderProps), (0, _toConsumableArray2.default)(programProps));
  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Form, {
    onSubmit: function onSubmit() {}
  }, function () {
    return /*#__PURE__*/_react.default.createElement("form", {
      className: "form-horizontal"
    }, /*#__PURE__*/_react.default.createElement(_ui.OverlaySpinner, {
      text: "Saving...",
      show: submitting
    }), /*#__PURE__*/_react.default.createElement(_ui.BaseCard, null, /*#__PURE__*/_react.default.createElement(_ui.BaseCardHeader, {
      title: "Email Notification Settings"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex pr-8",
      "data-test-element": "all_email_notifications"
    }, /*#__PURE__*/_react.default.createElement(_ui.UUToggleField, {
      value: notificationAll,
      onClick: function onClick() {
        (0, _utils.multiToggle)(allProps, !notificationAll, submitForm);
      },
      label: "Turn ".concat(notificationAll ? 'off' : 'on', " all notifications"),
      valueText: notificationAll ? 'On' : '',
      id: "toggle-all-on"
    }))), /*#__PURE__*/_react.default.createElement(_ui.BaseCardBody, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "p-2 text-text-blue"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4",
      "data-test-element": "notification_settings_content"
    }, (0, _utils.sectionHeader)(clientProps, clientAll, 'Clients', "Notifications about updates to your client's profile", 'clients', submitForm), /*#__PURE__*/_react.default.createElement("div", {
      className: "py-6 space-y-4"
    }, clientProps.map(function (propObject) {
      return (0, _utils.toggle)(propObject, submitForm);
    })), /*#__PURE__*/_react.default.createElement("hr", {
      className: "border-dark-border-blue"
    }), (0, _utils.sectionHeader)(referralProps, referralAll, 'Referrals & Cases', 'Notifications about referrals/cases you received, sent, opened, or were added to', 'referrals', submitForm), /*#__PURE__*/_react.default.createElement("div", {
      className: "py-6 space-y-4"
    }, referralProps.map(function (propObject) {
      return (0, _utils.toggle)(propObject, submitForm);
    })), /*#__PURE__*/_react.default.createElement("hr", {
      className: "border-dark-border-blue"
    }), showMessaging && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _utils.sectionHeader)(messageProps, messageAll, 'Messages', 'Notifications about messages you received', 'messages', submitForm), /*#__PURE__*/_react.default.createElement("div", {
      className: "py-6 space-y-4"
    }, messageProps.map(function (propObject) {
      return (0, _utils.toggle)(propObject, submitForm);
    })), /*#__PURE__*/_react.default.createElement("hr", {
      className: "border-dark-border-blue"
    })), paymentProps.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _utils.sectionHeader)(paymentProps, paymentAll, 'Payments', 'Notifications about updates to enrollments, authorizations, and invoices', 'payment', submitForm), /*#__PURE__*/_react.default.createElement("div", {
      className: "py-6 space-y-4"
    }, paymentProps.map(function (propObject) {
      return (0, _utils.toggle)(propObject, submitForm);
    })), /*#__PURE__*/_react.default.createElement("hr", {
      className: "border-dark-border-blue"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "p-4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-lg font-extrabold font-medium-font py-2"
    }, "Reminders"), /*#__PURE__*/_react.default.createElement("div", {
      className: "text-sm font-extrabold font-medium-font"
    }, "Get email reminders about referrals and cases that require action")), /*#__PURE__*/_react.default.createElement("div", {
      className: "py-2 px-4"
    }, reminderProps.map(function (propObject) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "py-2",
        key: propObject.name
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pb-2 text-sm font-medium-font text-text-blue"
      }, propObject.label), /*#__PURE__*/_react.default.createElement(_ui.RadioField, {
        id: propObject.name,
        value: propObject.value,
        onChange: function onChange(e) {
          return submitForm((0, _utils.getSubmitValue)(propObject.name, e.target.value, e.target.value !== 'off'));
        },
        options: reminderOptions
      }));
    })), /*#__PURE__*/_react.default.createElement("hr", {
      className: "border-dark-border-blue"
    }), (0, _utils.sectionHeader)(programProps, programAll, 'Programs', 'Notifications about updates to programs', 'programs', submitForm), /*#__PURE__*/_react.default.createElement("div", {
      className: "py-6 space-y-4"
    }, programProps.map(function (propObject) {
      return (0, _utils.toggle)(propObject, submitForm);
    })), showTasks && taskProps.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
      className: "border-dark-border-blue"
    }), (0, _utils.sectionHeader)(taskProps, taskAll, 'Tasks', 'Notifications about tasks', 'tasks', submitForm), /*#__PURE__*/_react.default.createElement("div", {
      className: "py-6 space-y-4"
    }, taskProps.map(function (propObject) {
      return (0, _utils.toggle)(propObject, submitForm);
    }))))))));
  });
};
NotificationSettings.propTypes = {
  submitForm: _propTypes.default.func.isRequired,
  submitting: _propTypes.default.bool.isRequired,
  currentEmployee: _propTypes.default.shape({
    notification_preferences: _propTypes.default.object.isRequired
  }).isRequired,
  enums: _propTypes.default.object.isRequired,
  flags: _propTypes.default.object.isRequired
};
var _default = exports.default = NotificationSettings;
//# sourceMappingURL=NotificationSettings.js.map